import { notifyError } from "../client/matteroomTab/Notification/NotificationContext";

export const showErrorGlobal = (error) => {
  let message = 'Unknown error occurred';

  if (error?.response?.data?.message) {
    message = error.response.data.message;
  } else if (typeof error === 'string') {
    message = error;
  } else if (error?.message) {
    message = error.message;
  }

  notifyError(message);
};